<template>
  <v-container>
    <h1 class="mt-10 mb-5">{{ $t('nav.about') }}</h1>
    <v-row>
      <v-col cols="12" md="8">
        <div class="item-body">
          <p><span class="bold-text" style="color:#01579B;">Shanghai Shunda CPA Co., Ltd.</span> is a trusted partner
            for
            businesses seeking
            professional, comprehensive, and efficient accounting and tax solutions. </p>
          <p>Established in 2003, we've been dedicated to helping enterprises thrive by ensuring financial accuracy and
            regulatory compliance.</p>
        </div>
        <div>
          <p style="text-indent: 2em;"></p>
          <p class="bold-text" style="color: grey; font-size: 24px;">Let's work together to achieve your financial
            goals.</p>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col cols="12" md="6">
        <div class="item-body">
          <h2>Our Services</h2>
          <p>We offer a range of services tailored to your specific needs:</p>
          <ul class="list-marked">
            <li><span class="bold-text">Audit and Accounting：</span>
              <p>Accurate and reliable financial reporting</p>
              <p>Enhanced financial transparency and control</p>
            </li>
            <li><span class="bold-text">Capital Verification：</span>
              <p>Credible certification for corporate fund operations</p>
              <p>Strengthened market reputation and investor confidence</p>
            </li>
            <li><span class="bold-text">Specialized Audits：</span>
              <p>Customized audit solutions for unique business requirements</p>
              <p>Risk mitigation and operational efficiency</p>
            </li>
            <li><span class="bold-text">Tax Consulting：</span>
              <p>Strategic tax planning and optimization</p>
              <p>Minimized tax liabilities and maximized after-tax profits</p>
            </li>
          </ul>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <div class="item-body">
          <h2>Our Team</h2>
          <p>Our experienced team of professionals is committed to delivering exceptional service. We combine:</p>
          <ul class="list-marked">
            <li><span class="bold-text">Deep Expertise: </span>A solid foundation in finance and taxation
            </li>
            <li><span class="bold-text">Practical Experience: </span>Tailored solutions for your unique business needs
            </li>
            <li><span class="bold-text">Client Focus: </span>Tailored solutions for your unique business needs</li>
          </ul>
        </div>
        <div class="item-body">
          <h2>Our Commitment</h2>
          <p>We strive to build long-lasting relationships with our clients, based on trust, transparency, and
            integrity. By choosing Shanghai Shunda CPA, you're choosing a partner that:</p>
          <ul class="list-marked">
            <li><span class="bold-text">Understands Your Business: </span>We take the time to learn your specific
              needs and challenges
            </li>
            <li><span class="bold-text">Delivers Results:</span>We provide timely and accurate solutions that drive
              growth
            </li>
            <li><span class="bold-text">Exceeds Expectations: </span>We go the extra mile to ensure your complete
              satisfaction</li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About',
}
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}

.item-body {
  width: 100%;
  padding-top: 5px;
  padding-bottom: 10px;
  line-height: 1.5;
}

.item-body>h2 {
  color: #01579B;
  margin-bottom: 10px;
}

.list-marked {
  text-align: left;
  font-weight: 300;
  font-size: 16px;
  margin-top: 16px;
  padding-left: 16px;
}

.list-marked>li {
  position: relative;
  padding-left: 10px;
  margin-top: 3px;
}
</style>